import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalCliente = ({
  show,
  onHide,
  onSave,
  cliente,
  documentos,
}) => {
  const [nombre, setNombre] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [numeroDocumento, setNumeroDocumento] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (cliente) {
      setNombre(cliente.nombre || "");
      setTipoDocumento(cliente.id_tipo_documento || "");
      setNumeroDocumento(cliente.numero_documento ? String(cliente.numero_documento) : "");
    } else {
      setNombre("");
      setTipoDocumento("");
      setNumeroDocumento("");
    }
    setError("");
  }, [cliente, show]);

  const handleSave = () => {
    if (!nombre || !tipoDocumento || !numeroDocumento.trim()) {
      setError("Todos los campos son obligatorios");
      return;
    }
    console.log("Enviando cliente:", {
      nombre: nombre,
      id_tipo_documento: tipoDocumento,
      numero_documento: numeroDocumento,
      tipo: typeof numeroDocumento
    });
    onSave({
      nombre: nombre,
      id_tipo_documento: tipoDocumento,
      numero_documento: numeroDocumento,
    });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{cliente ? "Editar Cliente" : "Nuevo Cliente"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Nombre del Cliente</Form.Label>
            <Form.Control
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Tipo de Documento</Form.Label>
            <Form.Select
              value={tipoDocumento}
              onChange={(e) => setTipoDocumento(e.target.value)}
              required
            >
              <option value="">Seleccione...</option>
              {documentos && documentos.map((doc) => (
                <option key={doc.id} value={doc.id}>
                  {doc.codigo}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Número de Documento</Form.Label>
            <Form.Control
              type="text"
              value={numeroDocumento}
              onChange={(e) => setNumeroDocumento(e.target.value)}
              required
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCliente; 